import { createSelector } from 'reselect';
import fanSelector from 'common/selectors/fanSelector';

export default createSelector(
    fanSelector,
    ({ profile: { settings = {} } = {} }) => {
        const { videoAutoStart: { value = null } = {} } = settings;
        return value;
    }
);



// WEBPACK FOOTER //
// ./app/common/selectors/fanAutoStartSelector.js